import { Volume1, Clock3, Leaf } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { PetitionCTA } from "@/components/PetitionCTA";

const CARDS = [
  {
    icon: Volume1,
    title: "Minder verkeersgeluid",
    body: "Bij hogere snelheden neemt met name het band-wegdekgeluid toe. Een lagere snelheid kan daarom de geluidbelasting voor de omgeving verminderen. RIVM-onderzoek naar snelwegen nabij stedelijk gebied laat zien dat een structurele verlaging naar 80 km/u een relevante reductie van verkeersgeluid kan geven.",
    testId: "impact-card-noise",
  },
  {
    icon: Clock3,
    title: "Nauwelijks extra reistijd",
    body: "Over ongeveer 7 kilometer bedraagt het theoretische verschil tussen continu 100 en continu 80 km/u ongeveer één minuut. Dit is een theoretische vergelijking bij constante snelheid — geen voorspelling van je werkelijke reistijd.",
    big: "± 1 minuut",
    bigSub: "voor kilometers meer rust",
    testId: "impact-card-time",
  },
  {
    icon: Leaf,
    title: "Minder uitstoot",
    body: "Een lagere kruissnelheid kan bij voertuigen met een verbrandingsmotor het brandstofverbruik en daarmee de CO₂-uitstoot verminderen. Het werkelijke effect hangt af van voertuigtype, verkeersbeeld, acceleraties en doorstroming. De kern van deze campagne blijft geluid en leefkwaliteit.",
    testId: "impact-card-emission",
  },
];

export const Impact = () => (
  <section id="feiten" data-testid="impact-section" className="scroll-mt-24 py-24 md:py-32">
    <div className="mx-auto max-w-[90rem] px-5 md:px-12">
      <Reveal>
        <Overline>De feiten</Overline>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-medium leading-tight tracking-tight text-gooi-green md:text-5xl lg:text-6xl">
          Een kleine verandering. Iedere dag effect.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3 md:gap-8">
        {CARDS.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.12}>
            <article
              data-testid={card.testId}
              className="flex h-full flex-col rounded-2xl bg-gooi-sand p-8 md:p-10"
            >
              <card.icon className="h-7 w-7 text-gooi-forest" strokeWidth={1.5} aria-hidden="true" />
              <h3 className="mt-6 font-display text-xl font-medium tracking-tight text-gooi-green md:text-2xl">
                {card.title}
              </h3>
              {card.big && (
                <div className="mt-6">
                  <p className="font-display text-5xl font-semibold tracking-tighter text-gooi-green md:text-6xl">
                    {card.big}
                  </p>
                  <p className="mt-1 text-sm font-semibold text-gooi-red">{card.bigSub}</p>
                </div>
              )}
              <p className="mt-5 text-sm leading-relaxed text-gooi-green/75 md:text-base">{card.body}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-14 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
        <PetitionCTA location="facts" />
        <p className="text-sm text-gooi-green/60">Samen voor 80 km/u</p>
      </Reveal>
    </div>
  </section>
);
